import { render } from "./EntryForm.vue?vue&type=template&id=2b1c8bf0"
import script from "./EntryForm.vue?vue&type=script&lang=js"
export * from "./EntryForm.vue?vue&type=script&lang=js"

import "./EntryForm.vue?vue&type=style&index=0&id=2b1c8bf0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__